export const ScrollToError = ({ errors }) => {
  const firstError = Object.keys(errors)[0];
  if (firstError) {
    const el = document.getElementsByName(firstError)[0];
    el && el.scrollIntoView({ block: "center", behavior: "smooth" });
  }
  return null;
};
